import React, { useState } from "react";
import { Download, Share } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useInstall } from "@/context/InstallContext";

export const InstallShortcutButton = ({ className = "" }) => {
  const ctx = useInstall();
  const [open, setOpen] = useState(false);

  // Only appears once the strip has been dismissed (permanent fallback entry point).
  if (!ctx || !ctx.canShow || !ctx.dismissed) return null;

  const onClick = async () => {
    const outcome = await ctx.install();
    if (outcome === "unavailable") setOpen((v) => !v);
  };

  return (
    <div className="relative">
      <Button
        onClick={onClick}
        variant="outline"
        className={`border-[#0D5C3A] text-[#0D5C3A] hover:bg-[#0D5C3A] hover:text-white ${className}`}
        data-testid="install-shortcut-nav-btn"
      >
        <Download className="h-4 w-4 sm:mr-1.5" />
        <span className="hidden sm:inline">Download app</span>
      </Button>
      {open && (
        <div
          className="absolute right-0 top-full z-[70] mt-2 w-64 rounded-xl border border-[#E5E0D8] bg-white p-3 text-left text-xs leading-relaxed text-stone-600 shadow-lg"
          data-testid="install-shortcut-help"
        >
          <span className="flex items-start gap-1.5">
            {ctx.isIOS && <Share className="mt-0.5 h-3.5 w-3.5 shrink-0 text-[#0D5C3A]" />}
            {ctx.helpText}
          </span>
        </div>
      )}
    </div>
  );
};
